
const state = {
  areas: []
}

const getters = {
  AllAreas (state) {
    return state.areas
  }
}

const actions = {
  setAreas (context, params) {
    context.commit('SETAREAS', params)
  },
  clearAreas (context, params) {
    context.commit('CLEAREAREAS', params)
  }
}

const mutations = {
  SETAREAS (state, params) {
    //  console.log('inside mutatiuons' + JSON.stringify(params))
    let index = state.areas.findIndex(item => item.item === params.item)
    //  console.log('Status index' + index)
    if (index) {
      state.areas.push(params)
    } else {
      // console.log('Index (' + params.item + ') ya esta')
    }
  },
  CLEAREAREAS (state) {
    state.areas = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/areas.js